import { cleanNumber, shownNumber } from './numbers';

// Текст поля живёт здесь: пока человек вводит, перерисовка формы со старым значением его не трогает.
export default {
  name: 'control-number-input',
  inheritAttrs: false,
  props: ['value'],
  data() {
    return { text: shownNumber(this.value) };
  },
  watch: {
    value(value) {
      if (document.activeElement !== this.$el) this.text = shownNumber(value);
    },
  },
  methods: {
    input(e) {
      const { target } = e;
      const { value, selectionStart } = target;
      const unsigned = Number(this.$attrs.min) >= 0;
      const cleaned = cleanNumber(value, unsigned);

      if (cleaned !== value) {
        const caret = cleanNumber(value.slice(0, selectionStart), unsigned).length;

        target.value = cleaned;
        target.setSelectionRange(caret, caret);
      }
      this.text = cleaned;
      this.$emit('input', e);
    },
    blur(e) {
      this.$emit('blur', e);
      this.$nextTick(() => {
        this.text = shownNumber(this.value);
      });
    },
  },
  render(h) {
    return h('input', {
      attrs: this.$attrs,
      domProps: { value: this.text },
      on: { ...this.$listeners, input: this.input, blur: this.blur },
    });
  },
};
